import { interact, URLS } from "fire-wind-water";
import { common } from "@/model/common";
import BaseComponent from "@/components/BaseComponent";
import { registerModel } from "@/model/register-model";
import configMixin from "@/mixin/config";
import Banner from "@/components/Banner";
import Header from "@/components/Header";

export default {
  name: "phoneRegister",
  components: {
    Header,
    Banner,
    BaseComponent,
  },
  mixins: [configMixin],
  data() {
    return {
      weChatId: common.weChatId,
      memberFormId: common.memberFormId, //  表单ID
      memberSchemaId: common.memberSchemaId,
      schemaId: common.schemaId, // 体系ID
      tenantId: common.tenantId,
      backUrl: common.backUrl,
      phone: URLS.getURL("phone") || URLS.getHash("phone"),
      code: URLS.getURL("code") || URLS.getHash("code"),
      country: URLS.getURL("country") || URLS.getHash("country"),
      formInfo: null,
      token: common.token,
      tokenInfo: "",
      verify: common.verify,
      formList: [],
      isSubmitting: false,
      inWeChat: interact.isWeChat,
      isLoad: false,
    };
  },
  methods: {
    routerLogin() {
      common.routerPush(this, "login");
    },
    afterLoadForm() {
      let self = this;
      let token = common.getToken();
      if (!token || !self.phone) {
        window.$sk.tips.show("请先授权再进行绑定！");
        common.routerPush(self, "login");
      } else {
        self.token = token;
      }
      if (this.formList && this.formList.length) {
        this.formList.map((item) => {
          if (item.fieldName == "mobile") {
            item.value = self.phone;
            if (item.isCallingCodeOpen == 1) {
              item.callingCodeLookupCountry = self.country;
              item.callingCodeLookupPhone = self.code;
            }
          }
        });
      }
    },
    beforeRegisterHandler() {
      registerModel.beforeRegisterHandler(this);
    },
    afterRegisterHandler() {
      common.removeToken();
    },
    skUserEnd() {
      let json = window.$sk.template.get();
      common.register(json);
      this.initConfig();
      registerModel.loadForm(this);
    },
    skLinkEnd() {
      this.verify = common.getVerify(this.weChatId);
    },
  },
  created() {
    window.$sk.loading.show();
    this.sk = window.$sk.template.module(this);
  },
  mounted() {},
  beforeDestroy() {
    this.sk.unsubscribe();
  },
};
